"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("show-test-heading", require("./Heading.vue").default);

exports.default = {
  props: ["type", "url", "test", "errors", "old", "project"]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tests/ShowTest.vue
// module id = euSw
// module chunks = 0 1